import BtnGroup from './containers/btn_group/BtnGroup';
import RuleTabel from './containers/rule_table/TablePage';
// import { useState } from 'react';
import './index.less';
import React, { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'dva';
import { Divider, Form, message } from 'antd';
import {
  handleFormData,
  hasUndefInObj,
  selectChangeIsRequired,
} from '../../../utils/breUtils';

const RuleEngine = (props) => {
  const { id, name } = props.location.query;
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  // 发起请求
  const fetchData = useCallback(() => {
    dispatch({
      type: 'mdCondition/getMdRuleList',
      payload: {
        values: {
          modelFieldId: id,
        },
      },
      callback: (d) => {
        if (d.code) {
          message.error(d.message);
          return;
        }
        //
      },
    });
  }, [dispatch, id]);
  useEffect(() => {
    fetchData();
  }, [fetchData]);
  //获取rule原来的数据
  const data = useSelector((state) => state.mdCondition.getMdRuleList);
  const ruleList = data;

  const onFinish = () => {
    const oldData = JSON.parse(JSON.stringify(ruleList));
    // (oldData || []).forEach((item) => (item['fieldId'] = id));
    const formVal = form.getFieldsValue();
    if (selectChangeIsRequired(formVal)) {
      message.warning('请填写完整');
      return;
    }

    const newdata = handleFormData(oldData, formVal);
    //对数据进行判空
    let isRequire = false;
    (newdata || []).forEach((item) => {
      if (!item.id) {
        delete item.id;
        delete item['0'];
        item['modelFieldId'] = id;
        item['fieldName'] = name;
        item['fieldType'] = 'INTEGER';
      }
      if (item['scoreType'] === 'VARIABLE') {
        item['score'] = item['score'] && item['score'][1];
      }
      // isRequire = hasUndefInObj(item);
      isRequire = hasUndefInObj(formVal, '');
    });
    if (isRequire) {
      message.warning('请填写完整');
      return;
    }
    // 保存接口
    dispatch({
      type: 'mdCondition/saveMdRuleList',
      payload: {
        values: {
          modelFieldId: id,
          modelExpressions: newdata,
        },
      },
      callback: (d) => {
        const { code } = d || {};
        if (code) {
          message.error(d?.message);
        } else {
          message.success('保存成功');
        }
        // form.resetFields(); //再次展开Form的列表首先清空
        fetchData();
      },
    });
  };
  const handleBtnCancel = () => {
    // 清除数据
    form.resetFields();
    fetchData();
  };

  return (
    <div className="re">
      <div className="contain">
        <Form form={form} name="rule">
          <BtnGroup
            {...props}
            id={id}
            name={name}
            handleSave={onFinish}
            handleCancel={handleBtnCancel}
          />
          <Divider />
          <RuleTabel
            name={name}
            id={id}
            fetchData={fetchData}
            form={form}
            {...props}
          />
        </Form>
      </div>
    </div>
  );
};

export default RuleEngine;
